(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.selectors = {
        slider: '[data-slider]',
        nextButton: '[data-next-button]',
        prevButton: '[data-prev-button]',
        pagination: '[data-pagination]',
        paginationHolder: '[data-pagination-holder]',
        playButton: '[data-play-button]',
        pauseButton: '[data-pause-button]',
      };
      this.options = {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: this.querySelector(this.selectors.nextButton),
          prevEl: this.querySelector(this.selectors.prevButton),
        },
        autoHeight: true,
        loop: true,
        on: {
          transitionEnd: () => {
            const activeSlide = this.querySelector('.swiper-slide-active');
            if (!activeSlide) {
              return;
            }
            activeSlide
              .querySelector('component-hero:not(.is-initialized)')
              ?.init();
            this.dataset.colorScheme =
              activeSlide.getAttribute('data-color-scheme') || 'dark';
            if (this.isPaused) {
              this.slider.autoplay.pause();
            }
          },
        },
      };
    }

    setupOptions() {
      if (this.hasAttribute('data-auto-rotate-speed')) {
        this.playButton = this.querySelector(this.selectors.playButton);
        this.pauseButton = this.querySelector(this.selectors.pauseButton);
        this.options.autoplay = {
          delay: Number(this.getAttribute('data-auto-rotate-speed')),
        };
      }

      const paginationEl = this.sliderEl.querySelector(
        this.selectors.pagination
      );
      if (!paginationEl) {
        return;
      }
      this.options.pagination = {
        el: paginationEl,
        clickable: !0,
      };
    }

    addPausePlayHandlers() {
      if (!this.playButton || !this.pauseButton) {
        return;
      }
      this.isPaused = false;
      this.paginationHolder = this.sliderEl.querySelector(
        '[data-pagination-holder]'
      );
      [this.playButton, this.pauseButton].forEach((button) => {
        button.addEventListener('click', this.togglePlayPause.bind(this));
      });
    }

    togglePlayPause(event) {
      event.preventDefault();
      this.isPaused = !this.isPaused;
      this.paginationHolder.classList.toggle('is-paused', this.isPaused);
      this.playButton.classList.toggle('hidden', !this.isPaused);
      this.pauseButton.classList.toggle('hidden', this.isPaused);
      if (this.isPaused) {
        this.slider.autoplay.pause();
        return;
      }
      this.slider.autoplay.resume();
    }

    init() {
      this.setupOptions();
      this.slider = new Swiper(this.sliderEl, this.options);
      this.querySelector('.swiper-slide-active component-hero')?.init();
      this.addPausePlayHandlers();
    }

    connectedCallback() {
      this.sliderEl = this.querySelector(this.selectors.slider);
      if (!this.sliderEl) {
        return;
      }
      this.init();
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
